<template>
    <div id="app-container" :class="{'print_mode': print_mode}">
        <header>
            <div id="logo"><a href="http://hoorucom.wpengine.com">HOO-R-U</a></div>
        </header>
        <main>
            <Results v-if="results && (step === 'results')" :results="results" :public_token="public_token"
                     :email_token="email_token" :badge_token="badge_token" :access_token="access_token"
                     :version="results['version'].startsWith('2.') ? 'dating' : 'default'"></Results>
            <Survey v-else-if="step === 'survey'" :callback="survey_done"></Survey>
            <Payment v-else-if="step === 'payment'" :access_token="access_token" :callback="payment_done"
                     :price_prop="price"></Payment>
            <div v-else-if="step === 'not-found'" id="page-not-found">Page not found</div>
            <Loader v-else></Loader>
        </main>
        <footer v-if="results" class="big-footer">
            <div>
                <h4>Follow us</h4>
                <ul>
                    <li><a href="https://www.facebook.com/HooruScore/">Facebook</a></li>
                    <li><a href="https://www.instagram.com/hoo.r.u.score/">Instagram</a></li>
                </ul>
            </div>
            <div>
                <h4>Subscribe to our newsletter</h4>
                <p><a href="https://signup.e2ma.net/signup/1908584/1406097/" @click="open_mailing_list">Join our mailing list for news and updates...</a></p>
            </div>
            <div>
                <ul class="site-info">
                    <li><a href="https://hoo-r-u.com/hoo-r-u-team/">HOO-R-U™ Team</a></li>
                    <li>(833) 90-HOO-R-U</li>
                    <li><a href="mailto:support@hoo-r-u.com">Support@HOO-R-U.com</a></li>
                    <li><a href="https://hoo-r-u.com/privacy/" target="_blank">Privacy Policy</a></li>
                    <li>© 2019 HOO-R-U™ All rights reserved</li>
                </ul>
            </div>
        </footer>
        <footer v-else>
            <p>© 2019 HOO-R-U™ All rights reserved | <a href="https://hoo-r-u.com/privacy/" target="_blank">Privacy
                Policy</a> | ver. 1.0.0.4</p>
        </footer>
    </div>
</template>

<script>
  import Ajax from './utils/Ajax';
  import Survey from './components/Survey';
  import Payment from './components/Payment';
  import Loader from './components/Loader';
  import Results from "./components/Results";
  import Helpers from "./utils/Helpers";

  export default {
    name: 'App',
    data: function () {
      return {
        'step': null,
        'session': null,
        'access_token': null,
        'price': null,
        'close_ask': false,
        'results': null,
        'public_token': null,
        'badge_token': null,
        'email_token': null,
        'print_mode': false
      }
    },
    beforeMount: function () {
      const so = Helpers.get_search_string();
      if (window.location.pathname === '/results.html') {
        if (so['id']) {
          const url = `${this.API_BASE}/results/${so['id']}`;
          Ajax.ajax('GET', url).then(r => {
            this.$data.results = r.response;
            const public_token = localStorage.getItem('public_token');
            const badge_token = localStorage.getItem('badge_token');
            const email_token = localStorage.getItem('email_token');
            const access_token = localStorage.getItem('access_token');
            if (public_token && (so['id'] === public_token)) {
              this.$data.public_token = public_token;
              this.$data.badge_token = badge_token;
              this.$data.email_token = email_token;
              this.$data.access_token = access_token;
            }
            this.$data.step = 'results';
          }).catch(() => {
            this.$data.step = 'not-found';
          });
        } else {
          this.$data.step = 'not-found';
        }
      } else {
        this.$data.step = 'survey';
      }
    },
    created: function () {
      window.addEventListener('beforeunload', (e) => {
        if (this.$data.close_ask) {
          e.preventDefault();
          e.returnValue = true;
        }
      });
      window.addEventListener('unload', () => {
        if (this.$data.session && !this.$data.access_token) {
          navigator.sendBeacon && navigator.sendBeacon(`${this.API_BASE}/stats/${this.$data.session}`, JSON.stringify({
            'name': 'LEAVE',
            'value': null
          }));
          window.gtag && window.gtag('event', 'questionnaire-action', {
            'event_category': 'leave',
          });
        }
      });
      const script = document.createElement('script');
      script.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${this.PAYPAL_CLIENT_ID}`);
      document.getElementsByTagName('head')[0].appendChild(script);
    },
    components: {
      Results,
      Payment,
      Survey,
      Loader
    },
    methods: {
      'survey_done': function (access_token, price) {
        this.$data.price = price;
        this.$data.access_token = access_token;
        if (price > 0) {
          this.$data.step = 'payment';
        } else {
          this.payment_done();
        }
      },
      'open_mailing_list': function (e) {
        e && e.preventDefault();
        window.open(e.target.getAttribute('href'), 'signup', 'menubar=no, location=no, toolbar=no, scrollbars=yes, height=300, width=500');
      },
      'payment_done': function () {
        this.$data.step = 'waiting-result';
        const interval = setInterval(() => {
          Ajax.ajax('GET', `${this.API_BASE}/status/${this.$data.access_token}`).then((r) => {
            if (r.response.result) {
              this.$data.close_ask = false;
              window.clearInterval(interval);
              r.response.scores['r'] = r.response.public_token;
              this.$data.public_token = r.response.public_token;
              this.$data.badge_token = r.response.badge_token;
              this.$data.email_token = r.response.email_token;
              localStorage.setItem('public_token', r.response.public_token);
              localStorage.setItem('badge_token', r.response.badge_token);
              localStorage.setItem('email_token', r.response.email_token);
              localStorage.setItem('access_token', this.$data.access_token);
              history.pushState({'step': 'results'}, 'My HOO-R-U™ Score', `/results.html?id=${r.response.public_token}&utm_source=results`);
              this.$data.results = r.response.scores;
              this.$data.step = 'results';
            }
          });
        }, 2000);
      }
    }
  }
</script>

<style src="./assets/cssreset-min.css"></style>
<style>
    @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700&display=swa');

    html {
        background: #f0f0f0;
        height: 100%;
        overflow: scroll;
        overflow-x: hidden;
    }

    #app-container.print_mode {
        background: #ffffff;
    }

    span.a {
        cursor: pointer;
        color: #8fbd52;
        border-bottom: 1px dotted;
    }

    body {
        height: 100%;
    }

    body, button, input {
        font-family: 'Roboto Condensed', sans-serif;
    }

    em {
        font-style: italic;
    }

    strong {
        font-weight: bold;
    }

    strong.green {
        color: #8fbd52;
        font-weight: normal;
    }

    strong.hidden {
        visibility: hidden;
    }

    .nowrap {
        white-space: nowrap;
    }

    #app {
        height: 100%;
        position: relative;
    }

    .questions-buttons {
        text-align: center;
    }

    label {
        cursor: pointer;
    }

    .btn-ext-wrapper {
        margin-top: 1rem;
    }

    .btn-ext-wrapper-center {
        text-align: center;
    }

    .btn-ext-wrapper button {
        padding: 0 3rem;
        font-size: 1.2rem;
        height: 3rem;
    }

    button {
        height: 2.6rem;
        padding: 0.7rem 1rem;
        font-size: 1rem;
        background: #ea9502;
        color: #ffffff;
        cursor: pointer;
        outline: none;
        transition: background-color 0.3s linear, color 0.3s linear;
        border: none;
    }

    button:hover {
        background: #000000;
        color: #ffffff;
    }

    button[disabled="disabled"],
    button[disabled="disabled"]:hover {
        background: #ffe6a3;
        color: #ffffff;
    }

    header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 199;
        box-shadow: 0 4px 10px -10px rgba(0, 0, 0, 0.6);
        padding: 1.25rem 3rem;
        height: 5rem;
        box-sizing: border-box;
        border-bottom: 1px solid #dddddd;
        background: #ffffff;
        min-width: 320px;
    }

    #app-container.print_mode header,
    #app-container.print_mode footer {
        display: none;
    }

    #app-container.print_mode main {
        padding: 0;
    }

    #app-container.print_mode .hide-for-print {
        display: none;
    }

    #app-container {
        position: relative;
        min-width: 320px;
    }

    header div#logo {
        max-width: 440px;
        width: 100%;
        overflow: hidden;
        height: 2.5rem;
        margin: 0 auto;
        background: url('./assets/img/hooru-logo.png') 50% 50% no-repeat;
        background-size: contain;
    }

    header div#logo a {
        text-indent: -10000px;
        display: block;
        width: 100%;
        height: 100%;
    }

    main {
        padding-top: 5rem;
        padding-bottom: 2rem;
    }

    footer {
        background: #000000;
        color: #dddddd;
        padding: 0.5rem;
        height: 1rem;
        text-align: center;
        position: fixed;
        z-index: 199;
        bottom: 0;
        left: 0;
        right: 0;
        font-size: 0.8rem;
        min-width: 320px;
    }

    footer.big-footer {
        position: static;
        margin-top: -2rem;
        height: auto;
        display: flex;
        padding: 1rem;
        text-align: left;
        font-size: 1rem;
    }

    footer.big-footer > * {
        padding: 1rem;
        box-sizing: border-box;
        width: 25%;
    }

    footer.big-footer > *:nth-child(2) {
        width: 50%;
    }

    footer.big-footer h4 {
        color: #8fbd52;
        font-size: 2rem;
        line-height: 2rem;
        margin-bottom: 0.5rem;
    }

    footer.big-footer > * > ul.site-info {
        font-size: 0.8rem;
    }

    footer.big-footer > * > ul > li {
        margin-bottom: 0.5rem;
    }

    footer.big-footer > * > ul > li:last-child {
        margin-bottom: 0;
    }

    footer a {
        color: inherit;
    }

    #page-not-found {
        padding: 3rem;
        font-size: 4rem;
        text-align: center;
    }

    @media only screen and (max-width: 800px) {

        footer.big-footer {
            display: block;
        }

        footer.big-footer > * {
            padding: 0;
            width: auto;
            margin-bottom: 1.5rem;
        }

        footer.big-footer > *:nth-child(2) {
            width: auto;
        }

        footer.big-footer > *:last-child {
            margin-bottom: 0;
        }

        footer.big-footer h4 {
            font-size: 1.2rem;
            line-height: 1.2rem;
        }

    }

    @media only screen and (max-width: 640px) {

        .btn-ext-wrapper {
            display: none;
        }

        .current .btn-ext-wrapper {
            display: block;
            z-index: 99;
            position: fixed;
            bottom: 2rem;
            left: 0;
            right: 0;
            padding: 1.5rem;
            background: linear-gradient(to bottom, rgba(240, 240, 240, 0.0) 0%, rgba(240, 240, 240, 0.75) 10%, rgba(240, 240, 240, 0.9) 100%);
        }

        .btn-ext-wrapper button {
            width: 100%;
        }
    }

</style>
